import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, DestroyRef, Input, OnInit, ViewChild, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NotificationService } from '@app/core/services';
import { DocumentsAGNotesReportContextService, documentsAGNotesReportContextFactory } from '@app/core/services/context/factory';
import { PlatformService } from '@app/core/services/context/platform.service';
import { ProductCasesLinesSelectionComponent } from '@app/products/dmepos/components/product-cases-lines-selection/product-cases-lines-selection.component';
import { ServiceLinesSelectionComponent } from '@app/products/pac/components/service-lines-selection/service-lines-selection.component';
import { ShellService } from '@mynexus/mfe-core';
import { ProductNames } from '@mynexus/mynexus-ui-lib';
import { finalize } from 'rxjs';

@Component({
    selector: 'mnc-documents-ag-notes-report',
    templateUrl: './documents-ag-notes-report.component.html',
    styleUrls: ['./documents-ag-notes-report.component.scss'],
    providers: [
        {
            provide: DocumentsAGNotesReportContextService,
            useFactory: documentsAGNotesReportContextFactory,
            deps: [HttpClient, ShellService]
        }
    ],
    standalone: false
})
export class DocumentsAGNotesReportComponent implements OnInit {
  @ViewChild('streamLineSelector', { static: false }) streamLineSelector: ProductCasesLinesSelectionComponent | ServiceLinesSelectionComponent
  @Input() authorizationByProductId!: string;
  @Input() lineData!: object[];

  selectedLines: object[] = [];
  infoMessage = '';
  pacIM = ProductNames.PACIM;
  // TODO: Remove PAC Commercial after LOB migration
  pacCom = ProductNames.PacCommercial;
  dmepos = ProductNames.DMEPOS;
  hh = ProductNames.HomeHealth;

  successMsg = 'Notes Report Downloaded';
  errorMsg = 'Unable to Download Notes Report. Something went wrong. Please try again later';
  noNotesMsg = 'Unable to Download Notes Report. The current selection contains no notes to download.';

  isLoading = false;

  readonly platformService = inject(PlatformService);
  private readonly agNotesReportService = inject(DocumentsAGNotesReportContextService);
  private readonly destroyRef = inject(DestroyRef);

  constructor(
    private readonly notificationService: NotificationService,
    private readonly shellService: ShellService) {
  }

  ngOnInit(): void {
    this.infoMessage = this.agNotesReportService.getInformationMessage();
  }

  clearFilters(): void {
    this.streamLineSelector.clearFilters();
  }

  downloadNotes(): void {
    this.isLoading = true;
    this.agNotesReportService.downloadAGNotes(this.shellService.getTenantId(), this.authorizationByProductId, this.selectedLines)
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        finalize(() => this.isLoading = false)
      )
      .subscribe({
        next: (response: string) => {
          if (response) {
            if (response === "General-137") {
              this.notificationService.showError(this.noNotesMsg);
            } else {
              const link = document.createElement('a');
              link.href = response;
              link.click();
              this.notificationService.showSuccess(this.successMsg);
              window.URL.revokeObjectURL(response);
            }
          } else {
            this.notificationService.showError(this.errorMsg);
          }
        },
        error: (error) => {
          if (!(error instanceof HttpErrorResponse && (error.status === 403 || error.status === 404))) {
            this.notificationService.showError(error.message);
          }
          else {
            this.notificationService.showError(this.errorMsg);
          }
      }});
  }

  handleLinesSelected(data: object[]): void {
    this.selectedLines = data;
  }
}
